export enum VerticalPositionOption {
  TOP = 'top',
  CENTER = 'center',
  BOTTOM = 'bottom'
}
